import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React, { Component } from 'react';
import { getProject } from '../../../common/services/project';
import { IBrand } from '../typings';

interface IProps {
  tableData: IBrand;
}
export class BrandRow extends Component<IProps> {
  public render() {
    const { tableData } = this.props;
    const { name } = tableData;
    const href = `#${getProject().url}/brands/${tableData.id}`;

    return (
      // @ts-ignore href
      <TableRow hover href={href} component="a">
        <TableCell>{name}</TableCell>
      </TableRow>
    );
  }
}
